document.addEventListener("DOMContentLoaded", () => {
  // Get modal and inner elements
  const modal = document.querySelector(".shop-the-look-modal");
  const modalInner = modal.querySelector(".shop-the-look-modal-inner");
  let previousURL = window.location.href;

  const reals = document.querySelectorAll(".real");

  const handleClose = () => {
    modalInner.classList.add("translate-y-full");

    setTimeout(() => {
      modal.classList.add("opacity-0");
    }, 50);

    setTimeout(() => {
      modal.classList.add("hidden");
      document.body.style.overflow = "auto";
    }, 200);

    window.history.pushState({}, "", previousURL);
  };

  reals.forEach((real) => {
    const shopTheLookButton = real.querySelector("button[data-modal-trigger]");

    shopTheLookButton.addEventListener("click", () => {
      const shopTheLookContent = document.querySelector(
        `.shop-the-look-modal-content[data-id="${real.dataset.id}"]`,
      );

      // Clone and append content to modal inner
      const contentClone = shopTheLookContent.cloneNode(true);
      contentClone.classList.remove("hidden");
      modalInner.innerHTML = "";
      modalInner.appendChild(contentClone);

      // Show modal with animation
      modal.classList.remove("hidden", "opacity-0");
      setTimeout(() => {
        modalInner.classList.remove("translate-y-full");
      }, 50);

      document.body.style.overflow = "hidden";

      // Close when clicking outside modal inner
      const handleModalClick = (e) => {
        if (!modalInner.contains(e.target)) {
          handleClose();
          modal.removeEventListener("click", handleModalClick);
        }
      };

      modal.addEventListener("click", handleModalClick);

      const shopTheLookCloseButton = modalInner.querySelector(
        ".shop-the-look-close-button",
      );
      shopTheLookCloseButton.addEventListener("click", handleClose);

      modalInner.querySelectorAll("label").forEach((label) => {
        label.addEventListener("click", (e) => {
          e.currentTarget.querySelector("input").checked = true;
          e.currentTarget
            .closest("form")
            .querySelector('input[name="id"]').value =
            e.currentTarget.querySelector("input").value;
        });
      });

      modalInner
        .querySelectorAll('button[type="submit"]')
        .forEach((submitButton) => {
          submitButton.addEventListener("click", function (event) {
            event.preventDefault();
            const form = submitButton.closest("form");
            const variantId = form.querySelector('input[name="id"]').value;
            const quantity = form.querySelector('input[name="quantity"]').value;

            fetch("/cart/add.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "X-Requested-With": "XMLHttpRequest",
              },
              body: JSON.stringify({
                items: [
                  {
                    id: variantId,
                    quantity: quantity,
                  },
                ],
              }),
            })
              .then((response) => {
                if (!response.ok) {
                  throw new Error("Network response was not ok");
                }
                return response.json();
              })
              .then((data) => {
                // handleClose();
              })
              .catch((error) => {
                console.error("Error adding to cart:", error);
              });
          });
        });
    });
  });

  // Close modal when clicking quick shop buttons
  document.addEventListener("click", (e) => {
    if (e.target.closest(".quick-shop-button")) {
      handleClose();
    }
  });

  // Close modal on Escape key
  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      handleClose();
    }
  });
});
